// A temporary Business only ever has a name and PICs with property names.
export type BusinessMatchedField = "name" | "pic" | "propertyName";

export const BUSINESS_MATCHED_FIELD_LABELS: Record<
  BusinessMatchedField,
  string
> = {
  name: "Name",
  pic: "PIC",
  propertyName: "Property Name",
};
